export default class AuthenticationError extends Error {
	public constructor(message?: string) {
		super(message);
		this.name = 'AuthenticationError';
	}
}
